<template>
  <div class="news">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">News</h4>
      <h1 class="jp-title">{{$t('news.title')}}</h1>
    </div>
    <section>
      <div class="jp-column text-left">
        <details-new v-if="newInfo" :new-info="newInfo"></details-new>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash';
import { getNew } from '@/api/websiteApi';
import dateFormat from '@/filters/formatTime';

import mainBg from '@/assets/img/news_bg.png';
import detailsNew from '@/components/detailsNew';
export default {
  name: 'news',
  components: {
    detailsNew
  },
  data () {
    return {
      mainBg: mainBg,
      newId: null,
      newInfo: null
    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.tabLang(val);
    }
  },
  created() {
    this.newId = this.$route.params.id;
    this.init();
  },
  methods: {
    init() {
      getNew(this.newId).then(res => {
        res.createTime = dateFormat.formatDate(new Date(res.createTime), 'yyyy-MM-dd')
        res.thumbnail = res.thumbnail ? this.imageBaseUrl + res.thumbnail.split('..')[1] : '';
        // res.thumbnail = this.imageBaseUrl + res.thumbnail;
        if (res.contentZh) {
          res.contentZh = res.contentZh.replace(/..\/UpLoadFile/g, this.imageBaseUrl + '/UpLoadFile');
        }
        if (res.contentEn) {
          res.contentEn = res.contentEn.replace(/..\/UpLoadFile/g, this.imageBaseUrl + '/UpLoadFile');
        }
        if (res.contentJa) {
          res.contentJa = res.contentJa.replace(/..\/UpLoadFile/g, this.imageBaseUrl + '/UpLoadFile');
        }
        this.newInfo = res;
        this.tabLang(this.$i18n.locale)
      })
    },
    tabLang(val) {
      switch(val) {
        case 'cn':
          this.newInfo.title = this.newInfo.titleZh;
          this.newInfo.content = this.newInfo.contentZh;
          break;
        case 'en':
          this.newInfo.content = this.newInfo.contentEn;
          this.newInfo.title = this.newInfo.titleEn;
          break;
        case 'jp':
          this.newInfo.content = this.newInfo.contentJa;
          this.newInfo.title = this.newInfo.titleJa;
          break;
        default:
          this.newInfo.title = this.newInfo.titleZh;
          this.newInfo.content = this.newInfo.contentZh;
          break;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 2rem;
  }

  .news-introduce {
    width: 1170px;
    margin: 0 auto;
    text-align: left;
    line-height: 2.25rem;
  }

  .jp-project-content {
    font-size: 1.4rem;
    .el-col {
      margin-bottom: 2.5rem;
    }
  }
}

@media (max-width: 768px){
  .news {
    section {
      .jp-project-content {
        font-size: 1.7rem;

        .el-image {
          max-height: 104px;
        }
      }
      .news-introduce {
        width: 100%;
        line-height: 2.5rem;
        font-size: 1.6rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/new.vue